import React, { Component } from 'react';

// material-ui
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import createMuiTheme from 'material-ui/styles/createMuiTheme'
import blue from 'material-ui/colors/blue';
import grey from 'material-ui/colors/grey';
import deepPurple from 'material-ui/colors/deepPurple';
import red from 'material-ui/colors/red';

import Header from './components/header'
import Main from './components/main'
import Footer from './components/footer'
import './styles/index.scss';

const theme = createMuiTheme({
  palette: {
    primary: deepPurple,
    secondary: blue,
    error: red,
    action: {
      disabledBackground: grey[50]
    }
  }
});

class App extends Component {

  render() {
    return (
      <MuiThemeProvider theme={theme}>
        <Header />
        <Main />
        <Footer />
      </MuiThemeProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js